const removeSpecialSigns = (str: string) =>
  typeof str === "string"
    ? str.replace(/[!@#$%^&()=+[\]{}|\\:;"'<>,.?/]/g, "")
    : str;

export default removeSpecialSigns;
